module.exports = {"210224100":"大长山岛镇","210224101":"獐子岛镇","210224102":"广鹿岛镇","210224103":"小长山岛镇","210224104":"海洋岛镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210224.json
// module id = 609
// module chunks = 0